import { createFileRoute } from "@tanstack/react-router";
import { AuthFlow } from "@/components/auth-flows";

export const Route = createFileRoute("/signin")({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => {
    const r = search["redirect"];
    return typeof r === "string" ? { redirect: r } : {};
  },

  head: () => ({
    meta: [
      { title: "Xamseen — Sign in" },
      { name: "description", content: "Sign in to Xamseen to pick up where you left off in your community." },
      { property: "og:title", content: "Sign in to Xamseen" },
      { property: "og:description", content: "Sign in to Xamseen to pick up where you left off in your community." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: SignInPage,
});

function SignInPage() {
  const { redirect } = Route.useSearch();
  return <AuthFlow initialMode="signin" redirectTo={redirect} />;
}
